export default __webpack_public_path__ + "static/media/1_Tune_Ivory_120x278_265.d5f51fd6.jpg";